export default __webpack_public_path__ + "static/media/whyVisit3.5df26d7c.svg";